/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_HingeInputs */

const en_us2_catalog_movement_hinge = /** @type {(inputs: Catalog_Movement_HingeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hip hinge`)
};

const pt_br2_catalog_movement_hinge = /** @type {(inputs: Catalog_Movement_HingeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dobradiça de quadril`)
};

const es_419_catalog_movement_hinge = /** @type {(inputs: Catalog_Movement_HingeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bisagra de cadera`)
};

const pt_pt2_catalog_movement_hinge = /** @type {(inputs: Catalog_Movement_HingeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dobradiça da anca`)
};

const fr_fr2_catalog_movement_hinge = /** @type {(inputs: Catalog_Movement_HingeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`charnière de hanche`)
};

const de_de2_catalog_movement_hinge = /** @type {(inputs: Catalog_Movement_HingeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hüftbeugen`)
};

const it_it2_catalog_movement_hinge = /** @type {(inputs: Catalog_Movement_HingeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hip hinge`)
};

/**
* | output |
* | --- |
* | "hip hinge" |
*
* @param {Catalog_Movement_HingeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_hinge = /** @type {((inputs?: Catalog_Movement_HingeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_HingeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_hinge(inputs)
	if (locale === "es-419") return es_419_catalog_movement_hinge(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_hinge(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_hinge(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_hinge(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_hinge(inputs)
	return en_us2_catalog_movement_hinge(inputs)
});
export { catalog_movement_hinge as "catalog.movement.hinge" }